export enum App {
  CompanyApp = 'companyApp',
  CompanyWeb = 'companyWeb',
  TenantApp = 'tenantApp',
  VendorApp = 'vendorApp',
  OwnerApp = 'ownerApp',
  Homepage = 'homepage',
  Internal = 'internal',
}

export enum Platform {
  Android = 'android',
  IOS = 'iOS',
  Web = 'web',
}

export enum VersionStatus {
  Ok = 'ok',
  Maintenance = 'maintenance',
  Upgrade = 'upgrade',
}

export interface AppVersion {
  appVersion?: string;
  status?: VersionStatus;
}
